export const ONE_SIGNAL_APP_ID = process.env.VUE_APP_ONE_SIGNAL_APP_ID;
